import React, { Component } from "react";
import PropTypes from "prop-types";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { SnackbarProvider } from 'notistack';
import { Provider } from "react-redux";
import * as routes from "constants/routes";

import withTheme from "hocs/withTheme";
// import Firebase, { FirebaseContext } from "./fbConfig";
import PrivateRoute from "./hocs/PrivateRoute";
import { ApplicationRoutes } from "./routes";
import SignInPage from "./containers/SignIn/SignInPage";
import SignUpPage from "./containers/SignUp/SignUpPage";

import Notifier from 'containers/Snackbar/Notifier'

import "./App.css";

// const LandingPage = () => (<h2>LandingPage</h2>)
const PasswordResetPage = () => <h2>PasswordResetPage</h2>;
const NoMatchPage = () => <h2>NoMatchPage</h2>;

class App extends Component {
  render() {
    return (
      <Provider store={this.props.store}>
        <SnackbarProvider maxSnack={3}>
          <div className="App">
            <Notifier />
            <BrowserRouter>
              <React.Fragment>
                <Switch>
                  <Route exact path={routes.LANDING} component={SignInPage} />
                  <Route exact path={routes.SIGN_IN} component={SignInPage} />
                  <Route exact path={routes.SIGN_UP} component={SignUpPage} />
                  <Route
                    exact
                    path={routes.PASSWORD_FORGET}
                    component={PasswordResetPage}
                  />
                  <PrivateRoute
                    path={routes.HOME}
                    component={ApplicationRoutes}
                  />
                  <Route component={NoMatchPage} />
                </Switch>
              </React.Fragment>
            </BrowserRouter>
          </div>
        </SnackbarProvider>
      </Provider>
    );
  }
}

App.propTypes = {
  store: PropTypes.object.isRequired
};

export default withTheme(App);
